import React, { useEffect, useState } from 'react';
import Select from "react-select";
import makeAnimated from "react-select/lib/animated";
import { urlObtenerOpciones } from '../../constants/urls';
import { Checkbox } from "react-inputs-validation";
import "../../styles/estilos.css";
import { Alert, Col, Row } from 'reactstrap';





const SiNo = ({
  id,
  value,
  valueSelect,
  placeholder,
  onChange,
  mensajeError,
  isSearchable,
  peticiones,
  valorPadre,
  esDependiente,
  codPadre,
  validate,
  hasError,
  validationCallback,
  values,
  setLoading,
  isMulti,
  valorDependiente,
  required,
  esBloqueante,
  errorBloqueante,
  disabled
}) => {

  const [options, setOptions] = useState([])



  useEffect(() => {


    console.log('verQuePasa', value)

  }, [value])


  useEffect(() => {


    if (values) {
      setOptions(values)
    }

  }, [values])


  useEffect(() => {
    if (peticiones != null) {
      obtenerOpciones()
    }

    if (values) {
      setOptions(values)
    }

  }, [esDependiente && valorPadre])

  const obtenerOpciones = async () => {



    setLoading(true)

    let url = `${urlObtenerOpciones}${peticiones.url}`;
    let body = peticiones.metodo == 'POST' ? JSON.stringify(peticiones.body) : null


    if (esDependiente) {
      if (peticiones.metodo == 'POST') {
        body = body.replace("$" + codPadre, valorPadre)
      }

      if (peticiones.metodo == 'GET') {
        url = url.replace("$" + codPadre, valorPadre.value)
      }





    }


    try {
      const response = await fetch(url, { method: peticiones.metodo, body: body })
      const json = await response.json()
      if (json) {



        let aux = []
        const atributo = peticiones.atributo;

        // Dividir la cadena de atributo en partes usando el punto como separador
        const partes = atributo.split(".");

        // Inicializar una variable temporal para mantener el objeto JSON actual
        let objetoActual = json;

        // Iterar sobre las partes para acceder al valor anidado en el objeto JSON
        for (const parte of partes) {
          objetoActual = objetoActual[parte];

          // Verificar si el objeto actual es indefinido o nulo
          if (objetoActual === undefined || objetoActual === null) {
            break;
          }
        }

        // opciones contendrá el valor final obtenido del objeto JSON
        let opciones = objetoActual;
        //let opciones = json[peticiones.atributo]

        opciones.forEach(p => {
          aux.push({ ...p, value: p[peticiones.value], label: p[peticiones.label] });
        });
        setOptions(aux)

      }
    } catch (error) {
    }

    setLoading(false)
  }


  return (
    <div title={"select"}>



      <Row>
        <Col md={2} sm={6} xs={6} >
          <Checkbox
            id={`preguntaSI`} // Optional.[String].Default: "".  Input ID.
            name={`preguntaSI`}
            //value={factotal} // Required.[String].Default: "".
            onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
            checked={value == 'SI'} // Required.[Bool].Default: false.
            onChange={(res, e) => {

              onChange('SI')
              validationCallback(true)

            }}
            labelHtml={
              <div style={{ color: '#4a4a4a', marginTop: '2px', fontWeight: "bold" }}>
                SI
              </div>
            } // Required.[Html].Default: none.
            validationOption={{
              name: 'preguntaSI', // Optional.[String].Default: "". To display in the Error message. i.e Please check the ${name}.
              check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
            }}
          />
        </Col>
        <Col md={2} sm={6} xs={6} >
          <Checkbox
            id={`preguntaNO`} // Optional.[String].Default: "".  Input ID.
            name={`preguntaNO`}
            //value={factotal} // Required.[String].Default: "".
            onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
            checked={value == 'NO'} // Required.[Bool].Default: false.
            onChange={(res, e) => {
              onChange('NO')
              validationCallback(false)
            }}
            labelHtml={
              <div style={{ color: '#4a4a4a', marginTop: '2px', fontWeight: "bold" }}>
                NO
              </div>
            } // Required.[Html].Default: none.
            validationOption={{
              name: 'preguntaNO', // Optional.[String].Default: "". To display in the Error message. i.e Please check the ${name}.
              check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
            }}
          />
        </Col>
      </Row>




      {value == 'SI' &&
        <Row  >
          <Col md={12} sm={12} >
            <Alert color="danger">
              <p style={{ textAlign: "center" }}><i className="fa fa-exclamation-triangle fa-2x" aria-hidden="true" ></i></p>
              <p style={{ textAlign: "center" }}>{'No se puede cotizar comuníquese con AIG.'}</p>

            </Alert>
          </Col>
        </Row>
      }



      {

        !value ?
          <div class="react-inputs-validation__msg___pxv8o react-inputs-validation__error___2aXSp">{mensajeError}</div> : null
      }





    </div>
  );
};

export default SiNo;
